import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconWarningFilled = () => {
  return (

      <g>
        <path
          d="M8.496.136a1 1 0 0 1 .361.36l7.005 12.002A.998.998 0 0 1 14.998 14H1a1 1 0 0 1-.864-1.502L7.129.497A1 1 0 0 1 8.496.136zM8 10.755c-.38 0-.693.279-.743.641l-.007.101v.26l.007.101c.05.363.363.642.743.642s.693-.28.743-.642l.007-.1v-.26l-.007-.102A.748.748 0 0 0 8 10.755zM8 3.5c-.38 0-.693.28-.743.642l-.007.1v4.545l.007.1c.05.363.363.642.743.642s.693-.28.743-.642l.007-.1V4.243l-.007-.101A.748.748 0 0 0 8 3.5z"
          
        />
      </g>
  );
};


export default withIcon(IconWarningFilled);
